type Props = {
  className?: string;
};

const ChevronLeft: FC<Props> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M9.49667 4.40248C9.38909 4.48374 9.06793 4.72634 8.88279 4.87083C8.51198 5.16021 8.01925 5.55561 7.52799 5.98215C7.03424 6.41085 6.55338 6.86119 6.19989 7.26126C6.02263 7.46187 5.88795 7.63809 5.80028 7.78351C5.71783 7.92028 5.70069 8.00107 5.70069 8.00107C5.70069 8.00107 5.71783 8.07949 5.80028 8.21625C5.88794 8.36167 6.02263 8.53789 6.19988 8.7385C6.55338 9.13858 7.03425 9.58892 7.528 10.0176C8.01926 10.4441 8.512 10.8396 8.88281 11.1289C9.06795 11.2734 9.38866 11.5157 9.49624 11.5969C9.71859 11.7607 9.76655 12.074 9.60279 12.2964C9.43904 12.5187 9.12604 12.5662 8.90369 12.4025L8.90213 12.4013C8.78943 12.3162 8.45656 12.0648 8.26758 11.9173C7.88839 11.6214 7.38112 11.2144 6.87239 10.7727C6.36614 10.3332 5.847 9.84938 5.4505 9.40064C5.25275 9.17684 5.07494 8.94998 4.94386 8.73253C4.82105 8.52882 4.70019 8.27089 4.7002 7.99988C4.7002 7.72887 4.82105 7.47095 4.94386 7.26723C5.07495 7.04979 5.25276 6.82293 5.4505 6.59913C5.847 6.15038 6.36613 5.6666 6.87238 5.22705C7.38111 4.78535 7.88837 4.3784 8.26755 4.08248C8.45661 3.93494 8.78934 3.68363 8.90191 3.5986L8.90334 3.59752C9.12569 3.43376 9.439 3.48103 9.60276 3.70337C9.76651 3.92571 9.719 4.23872 9.49667 4.40248Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronLeft;
